module.exports = __webpack_public_path__ + "img/xander-default.332fc13e.png";